<template>
  <div class="modal fade" ref="modal" @click.self="hide" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">

    <div class="modal-dialog" :class="{ 'modal-lg': large }" role="document">

      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <slot name="body"></slot>
        </div>

        <slot name="below-body"></slot>

        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-primary" @click="hide">Close</button>
          </slot>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
const $ = window.$

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    show () {
      const $modal = $(this.$refs.modal)

      $modal.one('shown.bs.modal', () => {
        this.$emit('shown')
      })
      $modal.modal('show')
    },
    hide () {
      const $modal = $(this.$refs.modal)

      $modal.one('hidden.bs.modal', () => {
        this.$emit('hidden')
      })
      $modal.modal('hide')
    }
  }
}
</script>
